import React, {useEffect, useState} from "react";
const classnames = require('classnames');

export interface ActionSheetProps {
    onChange?:(value:string) => void,
    list:Array<string>,
    value:number,
    label:string,
    placeholder:string,
}


const ActionSheet:React.FC<ActionSheetProps> = (props) => {
    const [show,setShow] = useState(false)
    const [active,setActive] = useState(0)
    const [select,setSelect] = useState(-1)

    useEffect(() => {
        setSelect(props.value)
    },[props.value])

    const handle = () => {
        setSelect(active)
        setShow(false)
        if(props.onChange){
            props.onChange(props.list[active])
        }

    }

    return <div className='action-sheet'>
        <div className="selector" onClick={() => setShow(true)}>
            {
                select === -1 ?
                    <p className='placeholder'>{ props.placeholder } <span className="iconfont">&#xe608;</span></p> :
                    <p className='value'>{ props.list[select] } <span className="iconfont">&#xe608;</span></p>
            }
        </div>
        {
            show && <div className="action-cover">
                <div className="action-box">
                    <h3>{ props.label }</h3>
                    <div className="action-lists">
                        {
                            props.list.map((item,index) => {
                                return <div onClick={() => setActive(index)} className={ classnames("action-item",{'active':active === index}) } key={index} >
                                    <p>{ item }</p>
                                </div>
                            })
                        }
                    </div>
                    <div className="sub" onClick={ handle }>确定</div>
                </div>
            </div>
        }
    </div>
}


export default ActionSheet
